module.exports = __webpack_public_path__ + "static/media/bathspa.82bcee48.webp";